import React, {forwardRef, useImperativeHandle} from 'react';
import { gql, useQuery } from '@apollo/client';

import DefaultError from '../components/defaulterror';
import { Loader } from '../components';
import { PracticeContent } from 'components';

const GET_EXERCISE = gql`
  query GetExercise($id: String!) {
    exercise(id: $id){
      id
      title
      description
      keytonic
    }
  }
`;
const Exercise = forwardRef(({id, keytonic, skipInstrumentTransponation, allowUserKey, isPreview}, ref) => {
  useImperativeHandle(ref, () => ({
    getExercise() {
      return data.exercise;
    }
  }));

  const { data, loading, error } = useQuery(
    GET_EXERCISE,
    { variables: { id: id } }
  );

  if (error) return <DefaultError error={error}/>//<p>SongStep ERROR {error.message}</p>;
  if (loading) return (
    <Loader />
  );
  if(!data.exercise)
  {
    return <p>Broken link</p>
  }
  return (
    <PracticeContent 
      title={data.exercise.title} 
      description={data.exercise.description} 
      org_keytonic={data.exercise.keytonic} 
      keytonic={keytonic || data.exercise.keytonic} 
      skipInstrumentTransponation={skipInstrumentTransponation} 
      allowUserKey={allowUserKey}
      isPreview={isPreview}/>
  )
});

export default Exercise;